import React from "react";

// const OtherChoice = ({isActive, onClick}) => {

//     return(
//         <div className={`other-choice ${isActive ? 'activeOtherChoice' : ''}`}>
//              <div className="row">
//                <div className="col-12 col-md-3">
//                  <div className="other-choice-box" onClick={onClick} style={{ cursor: 'pointer' }}>
//                    <p className="text-center">AUTRE CHOIX</p>
//                  </div>
//                </div>
//                <div className="d-flex flex-column" style={{ width: 400 }}>
//                  <label htmlFor="" className="label-be">
//                    Quelle Isolation
//                  </label>
//                  <input type="text" className='p-2' />
//                  <label htmlFor="" className="label-be mt-auto">
//                    Indiquez le poids du produit
//                  </label>
//                  {/* <input type="text"> */}
//                  <div className="input-wrapper">
//                    <input type="text" />
//                    <span className="unit">Kg/m²</span>
//                  </div>
//                </div>
//              </div>
//            </div>
//     )

// }


const OtherChoice = ({ isActive, onClick }) => {
  return (
    <div className={`other-choice ${!isActive ? 'activeOtherChoice' : ''}`}>
      <div className="row">
        <div className="col-12 col-md-3">
          <div className="other-choice-box" onClick={onClick} style={{ cursor: 'pointer' }}>
            <p className="text-center">AUTRE CHOIX</p>
          </div>
        </div>

        {isActive && (
          <div className="d-flex flex-column" style={{ width: 400 }}>
            <label htmlFor="" className="label-be">Quelle Isolation</label>
            <input type="text" className="p-2" />

            <label htmlFor="" className="label-be mt-auto">Indiquez le poids du produit</label>
            <div className="input-wrapper">
              <input type="text" />
              <span className="unit">Kg/m²</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OtherChoice;